import { h, Fragment } from 'preact'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useState } from 'preact/compat'
import SavedCard from '../SavedCard'
import SelectButton from '../../Common/SelectButton'
import LinkButton from '../../Common/LinkButton'
import { useTranslations } from '../../../hooks/useTranslations'
import { cardsSelector } from '../../../redux/slice/cardsSlice'

const CardsListSelection = ({ handleNewCard, handleUse }) => {
  const l10n = useTranslations()

  const { savedCards } = useSelector(cardsSelector)

  const [selectedCard, setSelectedCard] = useState(savedCards[0].id)

  const onChangeCardSelect = cardId => {
    setSelectedCard(cardId)
  }

  const onUse = e => {
    e.preventDefault()

    if (savedCards.length === 1) {
      handleUse(savedCards[0].id)
    } else {
      handleUse(selectedCard)
    }
  }

  const onAddNewCard = e => {
    e.preventDefault()
    handleNewCard()
  }

  return (
    <>
      {savedCards.map(card =>
        card.isExpired || savedCards.length === 1 ? (
          <SavedCard {...card} />
        ) : (
          <SelectButton
            key={card.id}
            name={card.maskedCardNumber}
            value={card.id}
            isChecked={card.id === selectedCard}
            className="card-select card clickable level-1"
            type="radio"
            onChange={onChangeCardSelect}
          >
            <SavedCard {...card} />
          </SelectButton>
        ),
      )}
      <div className="card-list-actions card clickable level-1">
        <LinkButton
          id="add-new-card-button"
          data-testid="add-card-button"
          title={l10n.t('Add new card')}
          onClick={onAddNewCard}
        />
        <button
          type="button"
          id="use-selected-card-button"
          className="button medium action-button primary"
          data-testid="use-selected-card-button"
          onClick={onUse}
        >
          {l10n.t('Use selected card')}
        </button>
      </div>
    </>
  )
}

CardsListSelection.propTypes = {
  handleNewCard: PropTypes.func.isRequired,
  handleUse: PropTypes.func.isRequired,
}

export default CardsListSelection
